/** Format minor units (cents) as ETB display string. */
export function etb(minor: number): string {
    return (Number(minor) / 100).toLocaleString('en-ET', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
}

/** Whole ETB amount from minor units (for compact UI pods). */
export function etbInt(minor: number): number {
    return Math.floor(Number(minor) / 100);
}

